/* Metall-Swatches auf der Produktkachel (Boss, 27.08.2026).

   Wechselt bei Hover/Klick/Fokus auf einen Swatch das Kachelbild, das
   Hover-Bild und das Klick-Ziel (?variant=) der Kachel.

   Bewusst per Event-Delegation auf document: Dawn tauscht beim Filtern und
   Sortieren das komplette Grid per AJAX aus. Direkt gebundene Listener waeren
   danach weg, die Delegation ueberlebt den Austausch.

   Wenn eine Kachel keine .boss-swatch-Buttons hat, passiert gar nichts --
   das Theme verhaelt sich dann exakt wie vorher.
*/
(function () {
  if (window.__bossSwatchReady) return;
  window.__bossSwatchReady = true;

  function swatchFrom(target) {
    if (!target || !target.closest) return null;
    return target.closest('.boss-swatch');
  }

  function apply(swatch) {
    var card = swatch.closest('.card-wrapper');
    if (!card) return;

    var media = card.querySelector('.card__media .media');
    var images = media ? media.querySelectorAll('img') : [];
    var main = images[0];
    var hover = images[1];

    var srcMain = swatch.getAttribute('data-boss-img');
    var srcHover = swatch.getAttribute('data-boss-hover');
    var url = swatch.getAttribute('data-boss-url');
    var alt = swatch.getAttribute('data-boss-alt');

    /* srcset leeren, sonst gewinnt der alte Kandidat gegen das neue src. */
    if (main && srcMain) {
      main.removeAttribute('srcset');
      main.src = srcMain;
      if (alt !== null) main.alt = alt;
    }
    if (hover && srcHover) {
      hover.removeAttribute('srcset');
      hover.src = srcHover;
    }

    /* Bild und Klickziel duerfen nie auseinanderlaufen. */
    if (url) {
      var links = card.querySelectorAll('a.full-unstyled-link');
      for (var i = 0; i < links.length; i++) links[i].href = url;
    }

    var siblings = swatch.parentNode.querySelectorAll('.boss-swatch');
    for (var j = 0; j < siblings.length; j++) {
      var active = siblings[j] === swatch;
      siblings[j].classList.toggle('is-active', active);
      siblings[j].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function preload(swatch) {
    if (swatch.dataset.bossPreloaded) return;
    swatch.dataset.bossPreloaded = '1';
    ['data-boss-img', 'data-boss-hover'].forEach(function (attr) {
      var url = swatch.getAttribute(attr);
      if (url) new Image().src = url;
    });
  }

  document.addEventListener('mouseover', function (event) {
    var swatch = swatchFrom(event.target);
    if (!swatch) return;
    preload(swatch);
    apply(swatch);
  });

  /* Touch: ohne Hover ist der Klick der einzige Weg. Der Klick darf dabei
     nicht bis zum Kachel-Link durchschlagen, sonst oeffnet sich das Produkt. */
  document.addEventListener('click', function (event) {
    var swatch = swatchFrom(event.target);
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();
    apply(swatch);
  });

  document.addEventListener('focusin', function (event) {
    var swatch = swatchFrom(event.target);
    if (!swatch) return;
    preload(swatch);
    apply(swatch);
  });
})();
